import { render } from "./MatchSetup.vue?vue&type=template&id=150519ae&scoped=true"
import script from "./MatchSetup.vue?vue&type=script&lang=js"
export * from "./MatchSetup.vue?vue&type=script&lang=js"

import "./MatchSetup.vue?vue&type=style&index=0&id=150519ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150519ae"]])

export default __exports__